import React, { useEffect, useState } from 'react';
import { preloadResources } from "./preloadResources";
import { VideoPlayer } from './Player';

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    preloadResources().then(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; // Puedes personalizar este indicador de carga
  }

  return (
    <div> 
      <VideoPlayer />
    </div>
  );
};

export default App;